export enum FilterOperator {
  EQUALS = 'eq',
  NOT_EQUALS = 'neq',
  CONTAINS = 'cts',
  LOWER_THAN = 'lt',
  NULL_OR_LOWER_THAN = 'nullOrLt',
  LOWER_THAN_EQUALS = 'lte',
  NULL_OR_LOWER_THAN_EQUALS = 'nullOrLte',
  GREATER_THAN = 'gt',
  NULL_OR_GREATER_THAN = 'nullOrGt',
  GREATER_THAN_EQUALS = 'gte',
  NULL_OR_GREATER_THAN_EQUALS = 'nullOrGte',
  IN = 'in',
  NOT_IN = 'nin',
  BETWEEN = 'btw',
  NOT_BETWEEN = 'nbtw',
  NULL = 'null',
  NOT_NULL = 'notNull',
}

export class QueryParams {
  public limit = 10;
  public size = 10;
  public page = 0;
  public offset = 0;
  /**
   * The key of the offset query parameter (in URI)
   */
  private readonly PARAM_OFFSET = 'offset';
  /**
   * The key of the limit query parameter (in URI)
   */
  private readonly PARAM_LIMIT = 'limit';
  /**
   * The key of the filter query parameter (in URI)
   */
  private readonly PARAM_FILTER = 'filter';
  /**
   * The key of the order query parameter (in URI)
   */
  private readonly PARAM_SORT = 'order';
  /**
   * The separator between the key and operator (for filter)
   */
  private readonly SEP_KEY_OPERATOR = '=';
  /**
   * The separator between the operator and the value (for filter)
   */
  private readonly SEP_OPERATOR_VALUE = ':';
  /**
   * The separator between each values in a filter with multiple values
   */
  private readonly SEP_VALUES = ',';
  /**
   * The separator between each filter
   */
  private readonly SEP_FILTERS = '!';
  /**
   * The separator between each order
   */
  private readonly SEP_ORDERS = '!';
  /**
   * The separator between the key and the order operator
   */
  private readonly SEP_KEY_ORDER = ':';
  private sort: string[] = undefined;
  private filter: Map<string, string> = new Map();

  public addFilter(key: string, operator: FilterOperator, ...values: string[]) {
    this.filter.set(key, `${operator}${this.SEP_OPERATOR_VALUE}${values}`);
  }

  public removeFilter(key: string) {
    this.filter.delete(key);
  }

  public resetFilters() {
    this.filter = new Map();
  }

  public setSort(value: string, order = 'asc') {
    if (!this.sort) {
      this.sort = [];
    }
    this.sort.push(`${value}${this.SEP_KEY_ORDER}${order}`);
  }

  public resetSort() {
    this.sort = undefined;
  }

  public buildParams(): string {
    let result = '';
    if (this.limit !== undefined) {
      result += `${this.PARAM_LIMIT}=${this.limit}&`;
    }
    if (this.offset) {
      result += `${this.PARAM_OFFSET}=${this.offset}&`;
    }
    if (this.sort && this.sort.length) {
      this.sort.forEach(s =>  {
        result += `${this.PARAM_SORT}=${this.sort}&`;
      });
    }
    if (this.filter.size > 0) {
      result += `${this.PARAM_FILTER}=`;
      this.filter.forEach((value, key) => {
        result += `${key}${this.SEP_KEY_OPERATOR}${value}${this.SEP_FILTERS}`;
      });
    }
    return result;
  }

  public getFilterByKey(key: string): string {
    return this.filter.get(key);
  }
}
